import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Dimmer } from "semantic-ui-react";

import { getParamPairs } from "../../../utils/utils";
import { sendVote } from "../VotifyParticipant/participantActionCreators";
import { dispatchCollectionRequest } from "./searchActionCreators";
import TracksWithVotesList from "../VotifyQueue/TracksWithVotesList";
import TrackListPlaceholder from "../VotifyQueue/TrackListPlaceholder";

class CollectionResults extends Component {
  componentDidMount() {
    const { collection } = getParamPairs(this.props.location.search);
    const [, type, id] = collection.split(":");
    this.props.sendCollectionRequest({ type, id });
  }
  render() {
    if (this.props.results) {
      return (
        <div>
          <Dimmer.Dimmable dimmed={this.props.isLoading} blurring>
            {(this.props.isLoading && <TrackListPlaceholder length={16} />) || (
              <TracksWithVotesList
                showImages
                participantVotes={this.props.participantVotes}
                tracks={this.props.results}
                clickVote={this.props.sendVote}
                votes={this.props.votes}
              />
            )}
          </Dimmer.Dimmable>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    results: state.search.collectionResults,
    isLoading: state.search.collectionIsLoading,
    miscSearchResults: state.search.miscSearchResults,
    participantVotes: state.participant.participantVotes,
    votes: state.participant.votes,
    location: state.router.location,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendCollectionRequest: (item) => dispatch(dispatchCollectionRequest(item)),
    sendVote: (trackUri) => dispatch(sendVote(trackUri)),
  };
};

CollectionResults.propTypes = {
  results: PropTypes.array.isRequired,
  participantVotes: PropTypes.object.isRequired,
  sendVote: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  votes: PropTypes.object,
  location: PropTypes.object,
  miscSearchResults: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CollectionResults);
